export default __webpack_public_path__ + "static/media/1651.e6265e15.png";